import React, { useEffect, useState } from "react";
import "./user-details.css";
import { Outlet, useNavigate, useSearchParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { FiCheckCircle } from "react-icons/fi";
import { SlClose } from "react-icons/sl";
import { GrSystem, GrOverview } from "react-icons/gr";
import { PiGenderIntersexDuotone } from "react-icons/pi";
import { IoDocumentsOutline } from "react-icons/io5";
import NavLinkTab from "../../../../ui/molecules/navlink-tab/NavLinkTab";
import Button from "../../../../ui/atoms/buttons/Button";
import InputText from "../../../../ui/atoms/inputs/input-text/InputText";
import InputTextArea from "../../../../ui/atoms/inputs/input-textarea/InputTextArea";
import NotFound from "../../../../ui/organisms/not-found/404";
//
import { onGetTeamMemberDetailsInformations } from "../../services/user";
import { configurationSlice } from "../../../../app/store/slices/configurationSlice";
import { useDispatch } from "react-redux";
import { capitalize, isEmpty } from "../../../../core/utils/helpers";

import useAxiosPrivate from "../../../../app/providers/context-provider/useAxiosPrivate";

const UserDetails = () => {
  const axiosPrivate = useAxiosPrivate();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const userId = searchParams.get("userId");

  const dispatch = useDispatch();

  const [isNotFound, setIsNotFound] = useState(false);
  const [currentTeamMemberData, setCurrentTeamMemberData] = useState({});

  const [onContact, setOnContact] = useState("");
  const [contactSubject, setContactSubject] = useState("");
  const [contactMessage, setContactMessage] = useState("");

  const initConnectedUser = useSelector(
    (state) => state.setInitConf.initConnectedUser,
  );
  const _sys_role = initConnectedUser?.sys_role;

  const currenTeamMemberId = useSelector(
    (state) => state.setInitConf.currentTeamMember?.id,
  );

  useEffect(() => {
    if (userId !== currenTeamMemberId) setIsNotFound(true);
  }, []);

  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();
    const signal = controller.signal;

    const localData = {
      curren_team_member_id: currenTeamMemberId,
    };

    onGetTeamMemberDetailsInformations(axiosPrivate, localData, signal).then(
      (response) => {
        const _data = response?.data?.result;
        dispatch(configurationSlice.actions.onCurrentTeamMemberData(_data));
        setCurrentTeamMemberData(_data);
      },
    );

    return () => {
      isMounted = false;
      isMounted && controller.abort();
    };
  }, []);

  return (
    <div className="user-details">
      <React.Fragment>
        {isNotFound ? (
          <NotFound
            type={"data"}
            title={"No Team member found!"}
            text={"No Team member available yet."}
            isBoutton={true}
          />
        ) : (
          <>
            <div className="user-details-infos">
              <button
                type="button"
                onClick={() => navigate(`/${_sys_role}/users`)}
              >
                ⬅️ Back to list
              </button>
              <div className="user-d-i-wrapper">
                <img
                  src={
                    isEmpty(currentTeamMemberData?.thumbnail)
                      ? process.env.PUBLIC_URL + "/user.png"
                      : `${process.env.REACT_APP_API_SERVER_URL}:${process.env.REACT_APP_API_SERVER_PORT}/storage/images/profiles/${currentTeamMemberData?.thumbnail}`
                  }
                  className={
                    currentTeamMemberData?.is_activated
                      ? "is-active"
                      : "is-inactive"
                  }
                />
                <div className="user-d-i-w-col">
                  <h1>{`${capitalize(
                    currentTeamMemberData?.firstname,
                  )} ${capitalize(currentTeamMemberData?.lastname)}`}</h1>
                  <div className="user-d-i-w-row mb-md gap-lg">
                    <div className="user-d-i-w-row">
                      {currentTeamMemberData?.is_activated ? (
                        <>
                          <FiCheckCircle className="icon is-active" />
                          <span>Active</span>
                        </>
                      ) : (
                        <>
                          <SlClose className="icon is-inactive" />
                          <span>Inactive</span>
                        </>
                      )}
                    </div>
                    <div className="user-d-i-w-row">
                      <GrSystem className="icon" />
                      <span>
                        {currentTeamMemberData?.sys_role === "user"
                          ? "System User"
                          : "System Administration"}
                      </span>
                    </div>
                    <div className="user-d-i-w-row">
                      <PiGenderIntersexDuotone className="icon" />
                      <span>
                        {currentTeamMemberData?.gender === "female"
                          ? "Woman"
                          : "Man"}
                      </span>
                    </div>
                  </div>
                  <div className="user-d-i-w-row gap-lg">
                    <Button
                      type={"button"}
                      preferedStyle={"default"}
                      title={"📧 Contact via E-mail"}
                      action={() => setOnContact("e-mail")}
                    />
                    <Button
                      type={"button"}
                      preferedStyle={"default"}
                      title={"💬 Contact via SMS"}
                      action={() => setOnContact("sms")}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="user-details-tab">
              <NavLinkTab
                style="style-2"
                tab_data={[
                  {
                    icon: GrOverview,
                    title: "Overview",
                    nav_to: `/${_sys_role}/users/details?userId=${userId}`,
                    is_exact: true,
                  },
                  {
                    icon: IoDocumentsOutline,
                    title: "Documents",
                    nav_to: `/${_sys_role}/users/details/documents?userId=${userId}`,
                    is_exact: false,
                  },
                ]}
              />
            </div>
            <div className="user-details-container">
              <Outlet />
            </div>
          </>
        )}
      </React.Fragment>
      <div
        className={
          !isEmpty(onContact)
            ? "user-details-contact slide-in"
            : "user-details-contact slide-out"
        }
      >
        <div className="user-details-contact-head">
          <div>
            <h1>Contact {onContact === "e-mail" ? "via E-mail" : "via SMS"}</h1>
            <p>
              You are about to send a{" "}
              {onContact === "e-mail" ? "E-mail" : "SMS"} to{" "}
              {`${capitalize(
                currentTeamMemberData?.firstname,
              )} ${capitalize(currentTeamMemberData?.lastname)}`}
            </p>
            <span>
              To address :{" "}
              <i>
                <strong>
                  {onContact === "e-mail"
                    ? currentTeamMemberData?.mail
                    : currentTeamMemberData?.telephone}
                </strong>
              </i>
            </span>
          </div>
          <Button
            type={"button"}
            preferedStyle={"danger"}
            title={"Close"}
            action={() => setOnContact("")}
          />
        </div>
        <div className="user-details-contact-body">
          <div className="w-full mb-md">
            <InputText
              type="text"
              name="contactSubject"
              title={"Subject"}
              value={contactSubject}
              onChange={(e) => setContactSubject(e.target.value)}
            />
          </div>
          <div className="w-full mb-md">
            <InputTextArea
              name="contactMessage"
              title={"Message"}
              value={contactMessage}
              onChange={(e) => setContactMessage(e.target.value)}
            />
          </div>
          <div className="w-fit-content m-auto">
            <Button
              type={"button"}
              preferedStyle={"normal"}
              title={"Send Message"}
              action={() => {}}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserDetails;
